import { deleteRequest, getRequest, patchRequest, postRequest } from 'services/requests';

export default {
    findTask: (id) => getRequest(`/tasks/${id}`),
    updateTask: (id, body) => patchRequest(`/tasks/${id}`, body),
    deleteTask: (id) => deleteRequest(`/tasks/${id}`),

    listTaskFeedbacks: (id, filter = null, orderBy = null, skip = null, top = 30) => {
        return getRequest(`/tasks/${id}/feedbacks?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`);
    },
    createTaskFeedback: (id, body) => postRequest(`/tasks/${id}/feedbacks`, body),

    findTaskFiles: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(`/tasks/${id}/files?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`);
    },
    createTaskFile: (id, body) => postRequest(`/tasks/${id}/files`, body),

    findTaskSharedUrls: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(`/tasks/${id}/shared-urls?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`);
    },
    createTaskSharedUrl: (id, body) => postRequest(`/tasks/${id}/shared-urls`, body),
};
